enum DictionaryActionTYPE {
  add = 'ADD',
  edit = 'EDIT',
}

export default DictionaryActionTYPE;
